import { createAction } from 'redux-act';

// get Department action
const getSidebarRequest = createAction('GET_SIDEBAR_REQUEST', data => data);
const getSidebarSuccess = createAction('GET_SIDEBAR_SUCCESS', data => data);
const getSidebarError = createAction('GET_SIDEBAR_ERROR');


export default {
    getSidebarRequest,
    getSidebarSuccess,
    getSidebarError,
}